import { render, staticRenderFns } from "./persistent-notification.vue?vue&type=template&id=9f4dc140&"
import script from "./persistent-notification.vue?vue&type=script&lang=ts&"
export * from "./persistent-notification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PersistentNotificationBase: require('/home/vsts/work/1/s/frontend/components/persistent-notification-base.vue').default})
